import Vuex from 'vuex';
var VueGlobalVariable = {
    install: function (Vue, options) {
        options = options || {};
        // const store = options.store || {state:{}}
        Vue.use(Vuex);
        var store = new Vuex.Store({ state: {} });
        var globals = options.globals || {};
        Object.keys(globals).forEach(function (key) {
            window["" + key] = globals[key];
            Vue.set(store.state, key, globals[key]);
        });
        var computed = {};
        Object.keys(globals).forEach(function (key) {
            computed["" + key] = function () { return globals[key]; };
        });
        Vue.mixin({
            computed: computed
        });
    }
};
export default VueGlobalVariable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-global-var/lib/index.js
// module id = 2QUw
// module chunks = 0